const styles = (theme) => ({
  root: {
    flex: 1,
    width: '100%',
    margin: 'auto',
    borderRadius: 12,
    background: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
  },
});

export default styles;
